import { LinkifyBox } from '@/lib/reactLinkify'

import { useSafeHtml } from './useSafeHtml'

export const SafeHtml = ({
  text,
  enable,
}: {
  text: string
  enable: boolean
}) => {
  const result = useSafeHtml({ text })
  return (
    <>
      {result === 'safe' &&
        (enable ? <span dangerouslySetInnerHTML={{ __html: text }} /> : null)}
      {result === 'unsafe' && <LinkifyBox>{text}</LinkifyBox>}
    </>
  )
}
